import { Button, IconPin } from 'uikit';

import type { ColDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import Styles from './TableSettings.module.css';

interface ICheckPin {
    onClick: (params: string) => void;
    applicableColumns: (ColDef & { isPinDefDisabled: boolean })[];
    currentPinnedState: string[];
    data: {
        name: string;
        colId?: string;
        value: string;
        disabled: boolean;
    };
}

export const CheckPin = ({ currentPinnedState, data, onClick, applicableColumns }: ICheckPin) => {
    const isPinned = useMemo(
        () => currentPinnedState.includes(data.colId ?? data.name),
        [currentPinnedState, data.colId, data.name],
    );

    const isPinDefDisabled = useMemo(
        () => applicableColumns.find((item) => item.headerName === data?.name)?.isPinDefDisabled,
        [applicableColumns, data?.name],
    );

    const toggleValue = useCallback(() => {
        onClick(data.colId ?? data.name);
    }, [data.colId, data.name, onClick]);

    const styleActive = isPinned ? Styles.active : '';

    return (
        <div className={Styles.wrapButton}>
            <Button
                className={styleActive}
                iconRight={IconPin}
                size="xs"
                onClick={toggleValue}
                view="clear"
                onlyIcon
                disabled={isPinDefDisabled}
            />
        </div>
    );
};

CheckPin.displayName = 'CheckPin';
